

function CallToAction() {

    return (
        <div className='cta-form'>
            <h2>Registrati ora e scegli il valore del tuo tempo! Ogni minuto può valere 100€ o più!</h2>
            <h2>CONTATTACI SU <a href="mailto:info@heqa.it">info@heqa.it</a></h2>
        </div>

    )
}

export default CallToAction